import { __extends } from "tslib";
import InMemoryStorage from './InMemoryStorage';
import SafeStorage from './SafeStorage';

var default_1 =
/** @class */
function (_super) {
  __extends(default_1, _super);

  function default_1(environmentPrefix) {
    var _this = this;

    var storageToUse;

    try {
      storageToUse = window.sessionStorage || InMemoryStorage;
    } catch (err) {
      storageToUse = InMemoryStorage;
    }

    _this = _super.call(this, storageToUse, environmentPrefix) || this;
    return _this;
  }

  return default_1;
}(SafeStorage);

export default default_1;